// DynamicMobileSearch.tsx
"use client";

import { useData } from "data/data-provider";
import MobileSearch from "../MobileSearchForm/MobileSearch";
import MobileSearch_2 from "../MobileSearchForm/MobileSerch_2";


const DynamicMobileSearch = () => {
  const { ourCompany } = useData();

  // Show long term rental search if allowed, else show short term version
  if (ourCompany?.allow_long_term_rentals) {
    return <MobileSearch />;
  }
  return <MobileSearch_2 />;
};

export default DynamicMobileSearch;